import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';
import { getWidgetFillColor } from '@/comp/MapBuilder/utils/utils';

const { useToken } = theme;

const WidgetWithIcon = ({
  ConnectivityIcon,
  isSelected,
  className,
  width = 35,
  height = 35,
  borderColor,
  widgetFillColor,
  ...rest
}: {
  ConnectivityIcon: JSX.Element;
  isSelected?: boolean;
  className?: string;
  width?: number;
  height?: number;
  borderColor?: string;
  widgetFillColor?: string;
  [x: string]: unknown;
}) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const currentWidgetFillColor = widgetFillColor ?? getWidgetFillColor(isSelected, token);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 50 44"
      className={className}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <circle cx="25" cy="22" r="22" fill={currentWidgetFillColor} />
          <path
            fill={borderColor ?? token.colorBorder}
            fillRule="nonzero"
            d="M25 0c10.07 0 18.56 6.766 21.172 16H48c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2h-1.828C43.56 37.234 35.07 44 25 44S6.44 37.234 3.828 28H2c-1.105 0-2-.895-2-2v-8c0-1.105.895-2 2-2h1.828C6.439 6.767 14.93 0 25 0zm0 2C13.954 2 5 10.954 5 22s8.954 20 20 20 20-8.954 20-20S36.046 2 25 2z"
          />
        </g>
        {ConnectivityIcon}
      </g>
    </svg>
  );
};

export default WidgetWithIcon;
